import {
  ResponsiveContextProvider,
  ResponsiveDetailCol,
  ResponsiveListCol
} from '@monorepo/common/component/responsive/ResponsiveContextProvider';
import Secured, { ROLE_DISCIPLINE_TRAINER } from '@monorepo/common/component/Secured';
import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import DisciplineConfigForTrainerDetail from '../component/discipline/trainer/DisciplineConfigForTrainerDetail';
import DisciplineConfigsForTrainerList from '../component/discipline/trainer/DisciplineConfigsForTrainerList';

export default function DisciplineConfigsForTrainerPage() {
  const { path: parentPath, url: parentUrl } = useRouteMatch();
  const path = `${parentPath}/:disciplineConfigId?`;
  const match = useRouteMatch<{ disciplineConfigId?: string }>(path);
  const disciplineConfigId = match?.params.disciplineConfigId;

  return (
    <Secured authority={ROLE_DISCIPLINE_TRAINER}>
      <ResponsiveContextProvider single={false} selectedId={disciplineConfigId}>
        <Route path={path}>
          <Container>
            <Row>
              <ResponsiveListCol>
                <div className="position-fixed-scrollable">
                  <DisciplineConfigsForTrainerList disciplineConfigId={disciplineConfigId} url={parentUrl} />
                </div>
              </ResponsiveListCol>

              <ResponsiveDetailCol>
                <DisciplineConfigForTrainerDetail disciplineConfigId={disciplineConfigId} listUrl={parentUrl} />
              </ResponsiveDetailCol>
            </Row>
          </Container>
        </Route>
      </ResponsiveContextProvider>
    </Secured>
  );
}
